import { Card, SkeletonBodyText } from "@medentic/polaris-react";
import { Patient } from "../../types";

interface DocumentsTabContentProps {
  patient?: Patient;
  loading?: boolean;
}

function DocumentsTabContent({ patient, loading }: DocumentsTabContentProps) {
  if (loading) {
    return (
      <Card>
        <SkeletonBodyText lines={10} />
      </Card>
    );
  }

  return <Card>{patient?.core_documents}</Card>;
}

export default DocumentsTabContent;
